export enum DraftSyncStatus {
  SYNCED = 'SYNCED',
  LOCAL_ONLY = 'LOCAL_ONLY',
  UNSYNCED_CHANGES = 'UNSYNCED_CHANGES',
  SAVING = 'SAVING',
}
